import { CODInput } from "../../ui/CODinput";

const buttonStyles = {
  save: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    background: "#07b1b0",
    color: "#fff",
    cursor: "pointer",
  },
  cancel: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
  },
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
  marginTop: "10px",
};

const AddUserForm = ({ formData, onChange, onSubmit, onCancel }) => {
  return (
    <form>
      <CODInput
        label="Email Address"
        type="email"
        name="email"
        value={formData.email}
        onChange={onChange}
        required
        title="Enter a email registered under your company domain"
      />
      <CODInput
        label="Username"
        type="text"
        name="userName"
        value={formData.userName}
        onChange={onChange}
        required
      />

      <div style={buttonContainerStyle}>
        <button type="submit" style={buttonStyles.save} onClick={onSubmit}>
          Save
        </button>
        <button type="button" onClick={onCancel} style={buttonStyles.cancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddUserForm;
